import { Typography, TypographyProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button, ButtonProps } from './button.component';

export type LinkButtonProps = Omit<ButtonProps, 'color' | 'variant'> & {
  color?: TypographyProps['color'];
  variant?: TypographyProps['variant'];
};

export const LinkButton: React.FC<LinkButtonProps> = ({ children, ...props }) => {
  const { classes } = useStyles();

  return (
    <Button
      className={classes.linkButton}
      {...props}
    >
      <Typography variant={props.variant} color={props.color} component="span">
        {children}
      </Typography>
    </Button>
  );
};

const useStyles = makeStyles()(theme => ({
  linkButton: {
    color: theme.palette.text.primary,
    padding: 0,
    textDecoration: 'underline',
    textTransform: 'none',
    verticalAlign: 'unset',
    '&:hover': {
      background: 'none',
      textDecoration: 'none'
    }
  }
}));
